import { getField, updateField } from "vuex-map-fields";

const getDefaultState = () => {
  return {
    RBF0404D40: {}, //고객별계좌거래내역발급조회 결과
    historyList: {}, //거래내역
    uniqueAcno: {}, //계좌번호
    inquryYmd: "", //조회년월
  };
};

const statementInq = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {},
};

export default statementInq;
